import { action, computed, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { EventIndexView } from '../../../../types/events';
import { EventApis } from '../../../../apis/events';
import { EventArchiveApis } from '../../../../apis/eventArchives';
import { ISODate } from '../../../../../commonv3/types/dates';
import { Predicates } from '../../../../../commonv3/utils/predicates';
import { getLocationFilter, LocationFilter, LocationSelector } from '../../../molecules/forms/LocationSelector';

export class EventListState {
    @observable events: RemoteResourceV3<EventIndexView[]> = RemoteResourceV3.loading();
    @observable eventArchives: RemoteResourceV3<EventIndexView[]> = RemoteResourceV3.loading();
    @observable selectedLocationIds = [];
    @observable selectedLocationSelectors: LocationFilter[] = [];

    @action.bound
    async init() {
        await Promise.all([
            updateRemoteResourceV3(this.events, (v) => (this.events = v), () => EventApis.findAll()),
            updateRemoteResourceV3(
                this.eventArchives,
                (v) => (this.eventArchives = v),
                () => EventArchiveApis.findAll()
            ),
        ]);
    }

    @action.bound
    setSelectedLocationIds(locationIds: Array<number>) {
        this.selectedLocationIds = locationIds;
    }

    @action.bound
    setSelectedLocationSelectors(locationSelectors: LocationFilter[]) {
        this.selectedLocationSelectors = locationSelectors;
    }

    @computed
    get filteredSessions() {
        return this.events
            .getOrElse([])
            .filter(Predicates.anyMatch(this.selectedLocationSelectors.map((s) => getLocationFilter(s))));
    }

    @computed
    get hasArchives(): boolean {
        return this.eventArchives.getOrElse([]).length > 0;
    }
}
